import '../assets/NcAppSidebarTab-XLBsrGqg.css';
import { n as r } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const s = {
  name: "NcAppSidebarTab",
  inject: ["registerTab", "unregisterTab", "getActiveTab", "isTablistShown"],
  props: {
    id: {
      type: String,
      required: !0
    },
    /**
     * Tab name in navigation
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Tab icon's html class in navigation. Used if #icon slot is not provided
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * Tab order in navigation. If not provided, name is used.
     */
    order: {
      type: Number,
      default: 0
    }
  },
  emits: [
    "bottom-reached",
    "scroll"
  ],
  expose: ["id", "name", "icon", "order", "renderIcon"],
  computed: {
    /**
     * Is the current tab an active tab, that should be shown?
     *
     * @return {boolean}
     */
    isActive() {
      return this.getActiveTab() === this.id;
    }
  },
  created() {
    this.registerTab(this);
  },
  beforeDestroy() {
    this.unregisterTab(this.id);
  },
  methods: {
    onScroll(t) {
      this.$el.scrollHeight - this.$el.scrollTop === this.$el.clientHeight && this.$emit("bottom-reached", t), this.$emit("scroll", t);
    },
    /**
     * Render tab's icon slot if any
     *
     * @return {import('vue').VNode[]}
     */
    renderIcon() {
      var t, e;
      return (e = (t = this.$scopedSlots).icon) == null ? void 0 : e.call(t);
    }
  }
};
var a = function() {
  var e = this, i = e._self._c;
  return i("section", { staticClass: "app-sidebar__tab", class: { "app-sidebar__tab--active": e.isActive }, attrs: { id: "tab-".concat(e.id), "aria-hidden": !e.isActive, "aria-label": e.isTablistShown() ? void 0 : e.name, "aria-labelledby": e.isTablistShown() ? "tab-button-".concat(e.id) : void 0, tabindex: e.isTablistShown() ? 0 : -1, role: e.isTablistShown() ? "tabpanel" : void 0 }, on: { scroll: e.onScroll } }, [i("h3", { staticClass: "hidden-visually" }, [e._v(" " + e._s(e.name) + " ")]), e._t("default")], 2);
}, n = [], o = /* @__PURE__ */ r(
  s,
  a,
  n,
  !1,
  null,
  "ef10d14f",
  null,
  null
);
const d = o.exports;
export {
  d as default
};
